/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import {
  WAREHOUSE_SCHEMA_V1_OPTIONS,
  WAREHOUSE_SCHEMA_V2_V3_SUPPORTED_OPTIONS,
  WAREHOUSE_SCHEMA_V4_OPTIONS,
  WarehouseDataOptionID,
} from 'cio/utils/warehouse';
import WarehouseSyncModel from 'cio/models/warehouse-sync';

interface WarehouseSyncUpdateSchemaVersionArgs {
  model: WarehouseSyncModel;
  isShowingModal: boolean;
  toggleModal: () => unknown;
  updateSchemaVersionTask: unknown;
  readonly: boolean;
}

export default class WarehouseSyncUpdateSchemaVersion extends Component<WarehouseSyncUpdateSchemaVersionArgs> {
  @tracked hasConfirmed = false;
  @tracked settings: Partial<Record<WarehouseDataOptionID, boolean>> = {};

  get availableOptions() {
    if (this.args.model.version === 1) {
      return WAREHOUSE_SCHEMA_V4_OPTIONS.filter((option) => !WAREHOUSE_SCHEMA_V1_OPTIONS.includes(option));
    }

    return WAREHOUSE_SCHEMA_V4_OPTIONS.filter((option) => !WAREHOUSE_SCHEMA_V2_V3_SUPPORTED_OPTIONS.includes(option));
  }

  constructor(owner: unknown, args: WarehouseSyncUpdateSchemaVersionArgs) {
    super(owner, args);

    this.settings = this.availableOptions.reduce((acc, option) => {
      return {
        ...acc,
        [option.id]: true,
      };
    }, {});
  }

  @action
  updateOption(key: WarehouseDataOptionID, value: boolean) {
    this.settings = {
      ...this.settings,
      [key]: value,
    };
  }

  @action
  toggleModal() {
    this.hasConfirmed = false;
    this.args.toggleModal();
  }
}
